module.exports = __webpack_public_path__ + "static/media/citadel.b7cbcedb.svg";